import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, NoAuthGuard } from '@libs/core/auth';
import { CarrierGuard } from './authentication/role-guard';
import { hasAcceptedPrivacyPolicy } from '@libs/core/privacy-policy';

const routes: Routes = [
  {
    path: 'drivers',
    loadChildren: () => import('./pages/drivers/drivers.module').then((m) => m.DriversModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy, CarrierGuard],
  },
  {
    path: 'packages',
    loadChildren: () => import('./pages/packages/packages.module').then((m) => m.PackagesModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: 'qr-code',
    loadChildren: () => import('./pages/qr-code/qr-code.module').then((m) => m.QrCodePageModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [NoAuthGuard],
  },
  {
    path: '',
    redirectTo: 'packages',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
